import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LayoutDashboard, BarChart3, Building2, Settings, Link2, Briefcase } from 'lucide-react';
import { cn } from '../../lib/utils';

const navItems = [
  { path: '/', icon: LayoutDashboard, labelKey: 'nav.dashboard' },
  { path: '/insights', icon: BarChart3, labelKey: 'nav.insights' },
  { path: '/job-promotions', icon: Briefcase, labelKey: 'nav.jobPromotions' },
  { path: '/accounts', icon: Building2, labelKey: 'nav.accounts' },
  { path: '/tiktok-mappings', icon: Link2, labelKey: 'nav.tiktokMappings' },
  { path: '/settings', icon: Settings, labelKey: 'nav.settings' },
];

export default function Sidebar() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <aside className="flex w-64 flex-col border-e bg-white">
      <div className="flex h-16 items-center justify-center border-b">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary text-white font-bold">
            S
          </div>
          <span className="text-lg font-semibold">SMI</span>
        </div>
      </div>

      <nav className="flex-1 space-y-1 p-4">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          const Icon = item.icon;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                'flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                isActive
                  ? 'bg-primary text-white'
                  : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'
              )}
            >
              <Icon className="h-5 w-5" />
              <span>{t(item.labelKey)}</span>
            </Link>
          );
        })}
      </nav>

      <div className="border-t p-4">
        <div className="text-xs text-gray-500">
          Social Media Insights v1.0.0
        </div>
      </div>
    </aside>
  );
}
